import React, { Component } from "react";
import PropTypes from "prop-types";
import { Radio, Divider, Select } from "antd";
const Option = Select.Option;
import FieldAggregation from "./charts/field-agg";

class Entities extends Component {
  static propTypes = {
    filter: PropTypes.object,
    enableDisplaySizeOption: PropTypes.bool,
    enableSortByOption: PropTypes.bool,
    fieldDisplaySize: PropTypes.number
  };

  static defaultProps = {
    filter: {},
    enableDisplaySizeOption: true,
    enableSortByOption: true,
    fieldDisplaySize: 20
  };

  state = {
    fieldAgg: "assignee_parent",
    fieldDisplaySize: this.props.fieldDisplaySize,
    sortByCategory: "number"
  };

  render() {
    const { enableDisplaySizeOption, enableSortByOption, ...rest } = this.props;
    return (
      <div style={{ width: "100%", textAlign: "center", minWidth: 435 }}>
        <Radio.Group value={this.state.fieldAgg} onChange={e => this.setState({ fieldAgg: e.target.value })}>
          <Radio.Button value="assignee_parent">{"Parent Company"}</Radio.Button>
          <Radio.Button value="assignee_original">{"Original Assignee"}</Radio.Button>
          <Radio.Button value="assignee_current">{"Current Assignee"}</Radio.Button>
        </Radio.Group>
        {enableSortByOption && (
          <>
            <Divider type="vertical" />
            <Select
              value={this.state.sortByCategory}
              placeholder="Sort By"
              onChange={val => this.setState({ sortByCategory: val })}
              getPopupContainer={trigger => trigger.parentNode}
              style={{ width: 180 }}
            >
              <Option value="number">{"Sort By #Patents"}</Option>
              <Option value="pvix_sum">{"Sort By Total PVIX"}</Option>
              <Option value="pvix_average">{"Sort By Average PVIX"}</Option>
              <Option value="pvix_median">{"Sort By Median PVIX"}</Option>
              <Option value="annuities">{"Sort By Renewal Fees"}</Option>
            </Select>
          </>
        )}

        {enableDisplaySizeOption && (
          <>
            <Divider type="vertical" />
            <Select
              value={this.state.fieldDisplaySize}
              placeholder="Display Size"
              onChange={val => this.setState({ fieldDisplaySize: val })}
              getPopupContainer={trigger => trigger.parentNode}
              style={{ width: 135 }}
            >
              <Option value={20}>{"Show Top 20"}</Option>
              <Option value={50}>{"Show Top 50"}</Option>
            </Select>
          </>
        )}
        <FieldAggregation field={this.state.fieldAgg} size={this.state.fieldDisplaySize} sortBy={this.state.sortByCategory} {...rest} />
      </div>
    );
  }
}

export default Entities;
